<template>
    <div>
        <div class="card shadow mb-4">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Add/ Edit Sensor</h6>
        </div>
                    
        <div v-for="x in FilterApplication" :key="x._id" class="card-body" >
        <form>
            <div class="form-group">
                <label for="exampleFormControlInput1">Nama Sensor</label>
                <input v-model="appname"  type="text" class="form-control"  placeholder="nama sensor">
            </div>
            <div class="form-group">
                <label for="exampleFormControlInput1">Latitude</label>
                <input v-model="latitude" type="text" class="form-control"  readonly placeholder="latitude">
            </div>
            <div class="form-group">
                <label for="exampleFormControlInput1">Longitude</label>
                <input v-model="longitude" type="text" class="form-control"  readonly placeholder="longitude">
            </div>
            <button type="button" class="btn btn-info btn-lg btn-block">Select Coordinates</button>
            <button type="button" class="btn btn-primary btn-lg btn-block">Submit</button>
           
            </form>
    </div>
    </div>
    </div>
</template>

<script>

export default {
    name:"SensorForm",


    data() {
    return {
      appname: '',
      latitude: '',
      longitude: '',
   
    }
  },


}
</script>